import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["data-cy"]
const _hoisted_3 = {
  key: 0,
  class: "label"
}

import { VIconSvg } from "@/components";
import { computed } from "vue";
import { kebabCase } from "lodash";
import { TranslateResult } from "vue-i18n";

interface Props {
  size?: string;
  label?: string | TranslateResult;
  disabled?: boolean;
  value?: boolean | string | number;
  positiveValue?: boolean | string | number;
  negativeValue?: boolean | string | number;
  description?: string | TranslateResult;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VToggle',
  props: {
    size: { default: "md" },
    label: { default: "" },
    disabled: { type: Boolean, default: false },
    value: { type: [Boolean, String, Number], default: false },
    positiveValue: { type: [Boolean, String, Number], default: true },
    negativeValue: { type: [Boolean, String, Number], default: false },
    description: { default: "" }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const toggleClasses = computed(() => {
  return {
    "toggle-disabled": props.disabled,
  };
});

const sizeClasses = computed(() => {
  return {
    "size-sm": props.size === "sm",
    "size-md": props.size === "md",
  };
});

const toggleValue = computed({
  get() {
    return props.value === props.positiveValue;
  },

  set(value) {
    emit("input", value ? props.positiveValue : props.negativeValue);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toggle-wrapper", toggleClasses.value])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["switch", sizeClasses.value])
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toggleValue).value = $event)),
        disabled: _ctx.disabled,
        type: "checkbox"
      }, null, 8, _hoisted_1), [
        [_vModelCheckbox, toggleValue.value]
      ]),
      _createElementVNode("span", {
        class: "slider round",
        "data-cy": `toggle-${_unref(kebabCase)(_ctx.label)}`
      }, null, 8, _hoisted_2)
    ], 2),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.description)
      ? (_openBlock(), _createBlock(_unref(VIconSvg), {
          key: 1,
          tooltip: _ctx.description,
          name: "InfoCircle2",
          color: "fc-stroke",
          size: "xs"
        }, null, 8, ["tooltip"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})